import {
  ApiBlobGetRequest,
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Transfer Kas',
    title_form: 'Form Transfer Kas',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Transfer Kas',
        href: '/adm/fin/kas-bank/transfer-kas',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_transfer_kas',
    sortDesc: true,
    fields: [
      {
        key: 'code_transfer',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'tgl_transfer',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'ref',
        label: 'Ref',
        sortable: true,
      },
      {
        key: 'memo',
        label: 'Notes',
        sortable: true,
      },
      {
        key: 'nominal_transfer',
        label: 'Total',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      tgl_transfer: '',
      memo: '',
      acc_from: '',
      acc_from_code: '',
      acc_from_name: '',
      acc_destination: '',
      acc_destination_code: '',
      acc_destination_name: '',
    },
    journal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeTransferKas(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getJournalTransferKas({ commit }, paylad = null) {
    commit('changeTransferKas', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/transfer-kas/${paylad.id}/journal`);
    commit('changeTransferKas', {
      loading: false,
      journal: result.error ? [] : result.data.object,
    });

    return !result.error ? true : false;
  },

  async getTransferKas({ commit, state }, payload = {}) {
    commit('changeTransferKas', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/transfer-kas`, params);
      commit('changeTransferKas', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_transfer_kas.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest('fin/transfer-kas', params);
      commit('changeTransferKas', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailTransferKas({ commit, state }, payload = null) {
    commit('changeTransferKas', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/transfer-kas/${payload.id}`);
    commit('changeTransferKas', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTransferKas', {
        form: {
          ...data.form,
          ...result.data.object,
          tgl_transfer: result.data.object.tgl_transfer
            ? moment(result.data.object.tgl_transfer).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async createTransferKas({ commit, state, dispatch }) {
    commit('changeTransferKas', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/transfer-kas', data.form);

    commit('changeTransferKas', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateTransferKas({ commit, state, dispatch }, payload = null) {
    commit('changeTransferKas', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `fin/transfer-kas/${payload.id}`,
      data.form
    );

    commit('changeTransferKas', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteTransferKas({ commit, dispatch }, payload = null) {
    commit('changeTransferKas', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/transfer-kas/${payload.id}`);
    commit('changeTransferKas', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getDetailSetupAccount({ commit }, payload = null) {
    commit('changeTransferKas', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/transfer-kas/${payload.id}`);
    commit('changeTransferKas', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTransferKas', {
        detail: result.data.object,
      });
    }

    return !result.error ? true : false;
  },
};
